import { PopupsActionsTypes } from "./popup.types";

const INITIAL_STATE = {
  isPopupsPending: false,
  popups: [],
  popupsError: null,
};

const PopupsReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case PopupsActionsTypes.GET.POPUPS_PENDING:
      return {
        ...state,
        isPopupsPending: true,
      };

    case PopupsActionsTypes.GET.POPUPS_SUCCESS:
      return {
        ...state,
        isPopupsPending: false,
        popups: action.payload,
        popupsError: null,
      };

    case PopupsActionsTypes.GET.POPUPS_ERROR:
      return {
        ...state,
        isPopupsPending: false,
        popupsError: action.payload,
      };

    default:
      return state;
  }
};

export default PopupsReducer;
